import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumBpSessionErrorReason implements BaseEnumType {
  private static allValues: EnumBpSessionErrorReason[] = []; // make sure this is top-most
  
  public static none = new EnumBpSessionErrorReason(0, "None", "enum_bp_session_error_reason_none");
  public static notFound = new EnumBpSessionErrorReason(1, "NotFound", "enum_bp_session_error_reason_not_found");
  public static onHold = new EnumBpSessionErrorReason(2, "OnHold", "enum_bp_session_error_reason_on_hold");
  public static invalidCredentials = new EnumBpSessionErrorReason(3, "InvalidCredentials", "enum_bp_session_error_reason_invalid_credentials");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumBpSessionErrorReason.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumBpSessionErrorReason.none; }
  public isNotFound() { return this === EnumBpSessionErrorReason.notFound; }
  public isOnHold() { return this === EnumBpSessionErrorReason.onHold; }
  public isInvalidCredentials() { return this === EnumBpSessionErrorReason.invalidCredentials; }

  public static getValues(): readonly EnumBpSessionErrorReason[] {
    return EnumBpSessionErrorReason.allValues;
  }

  public static getValuesExcept0(): readonly EnumBpSessionErrorReason[] {
    return EnumBpSessionErrorReason.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumBpSessionErrorReason {
    const found = EnumBpSessionErrorReason.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumBpSessionErrorReason - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumBpSessionErrorReason): EnumBpSessionErrorReason {
    const found = name ? EnumBpSessionErrorReason.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumBpSessionErrorReason - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumBpSessionErrorReason>): boolean {
    return this.key === other?.key;
  }
}